import { render, staticRenderFns } from "./AddInventoriesModal.vue?vue&type=template&id=ca93e076&scoped=true"
import script from "./AddInventoriesModal.vue?vue&type=script&lang=js"
export * from "./AddInventoriesModal.vue?vue&type=script&lang=js"
import style0 from "./AddInventoriesModal.vue?vue&type=style&index=0&id=ca93e076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca93e076",
  null
  
)

export default component.exports